// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EfficiencyMark_wrapper_3Jnqz"};